import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatusButtons } from "../../../../_shared/interfaces";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { AlertService, IAlertType, RequestsStoreService } from "../../../../_shared/services";
import { ClrCommonFormsModule, ClrIconModule} from "@clr/angular";

import { JsonPipe, NgIf} from "@angular/common";
import { ClarityIcons, exclamationCircleIcon, floppyIcon} from "@cds/core/icon";

import { environment as env } from '../../../../../environments/environment';

@Component({
  selector: 'app-request-edit-position',
  standalone: true,
  imports: [
    ClrCommonFormsModule,
    ReactiveFormsModule,
    NgIf,
    ClrIconModule,
    JsonPipe
  ],
  templateUrl: './request-edit-position.component.html',
  styleUrl: './request-edit-position.component.sass'
})
export class RequestEditPositionComponent implements OnInit {

  public editRequestsForm!: FormGroup;
  positions: any; // PositionsList[] = [];
  loading = false;
  statusLabel = 'label-light-blue';
  statusText = '';

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'label-warning', icon: 'exclamation-triangle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'label-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'label-info', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'label-info', icon: 'check-circle'},
    { state: 'answered', display: 'Beantwortet', label: 'label-info', icon: 'check-circle'},
    { state: 'favored', display: 'Auftrag', label: 'label-success', icon: 'check-circle'},
  ];

  @Input() projectNumber: string = '';
  @Input() requestNumber: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  devMode: boolean = false;

  constructor(
    private reqss: RequestsStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    this.loadRequestsPosition(this.projectNumber, this.requestNumber, this.editPosition, this.editPart);
  }

  initForm() {
    if (this.editRequestsForm) {
      return;
    }

    this.editRequestsForm = this.fb.group({
      project_number: [this.projectNumber],
      reqid: [this.requestNumber],
      position: [this.editPosition],
      part: [this.editPart],
      name: [this.positions[0].name],
      technical_drawing: [this.positions[0].technical_drawing],
      material: [this.positions[0].material],
      serial_nr: [this.positions[0].serial_nr],
      heat_nr: [this.positions[0].heat_nr],
      controlling_nr: [this.positions[0].controlling_nr],
      weight: [this.positions[0].weight],
      description: [this.positions[0].description],
      remarks:  [this.positions[0].remarks],
      side_agreements: [this.positions[0].side_agreements],
      purchasing_price:  [this.positions[0].purchasing_price],
      request_position_status:  [this.positions[0].request_position_status],
      number_of_pieces: [this.positions[0].number_of_pieces],
      technology:  [this.positions[0].technology],
      taric:  [this.positions[0].taric],
      comment_phm: [this.positions[0].comment_phm],
      specification: [this.positions[0].specification],
    });
  }

  loadRequestsPosition(prid: string, reqid: number, posid: number, partid: number) {
    const posID = posid.toString();
    this.reqss.getRequestsPositions(prid, reqid, posID, partid, "all").subscribe({
      next: data => {
        if (!data || data.hasErrors || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Request-Position konnte nicht geladen werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
      this.positions = data.object;

      if (this.devMode) console.table(data);
      if (this.devMode) console.table(this.positions);

      this.initForm();
    },
    error: (error) => {
      this.alertDispatcher.show({
        message: 'Fehler beim Laden der Position: ' + error,
        clrAlertType: IAlertType.DANGER
      }, 5000);
    }
    });
  }

  updateRequestsPosition() {
    if (this.editRequestsForm.valid) {
      const formValue = this.editRequestsForm.value;
    this.reqss.updateRequestsPosition(formValue).subscribe({
    next: () => {
      this.alertDispatcher.show({
        message: 'Position erfolgreich aktualisiert',
        clrAlertType: IAlertType.SUCCESS
      }, 5000);

      this.updatedPosition.emit(true);
    },
      error: (error) => {
        this.alertDispatcher.show({
          message: 'Fehler beim Aktualisieren der Position: ' + error,
          clrAlertType: IAlertType.DANGER
        }, 5000);
      }
    });
    }
  }

  cancelEdit() {
    this.updatedPosition.emit(true);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };
}
